import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import { ApolloProvider } from '@apollo/react-hooks';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { from } from 'apollo-link';
// import './embed';
import scriptjs from 'scriptjs';
import App from './components/App';

import {
  authLink,
  omitTypeNameLink,
  errorLink,
  uploadLink,
  apiHost,
} from './graphql/ApolloLinks';

export const client = new ApolloClient({
  link: from([
    authLink,
    omitTypeNameLink,
    errorLink,
    // httpLink,
    uploadLink,
  ]),
  cache: new InMemoryCache(),
});

scriptjs(`${apiHost}/embed.js`, () => {
  console.log('embedded successfully');
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById('root'),
);
